import { type FC, type ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { _notNil } from '@/littledash';
import type { AgentType } from '@/model/Agent.model';
import AgentBreadcrumb from '@/components/Agents/AgentBreadcrumb/AgentBreadcrumb';
import { parseAgentUrlSlug } from '@/components/Agents/AgentUtils';
import StudyHealthSetupForm from './Forms/StudyHealthSetupForm';
import StudyProtocolParserSetupForm from './Forms/StudyProtocolParserSetupForm';

interface AgentFormConfig {
  label: string;
  render: () => ReactElement;
}

/** Maps agent slugs to their setup form config. */
const agentForms: Record<AgentType, AgentFormConfig> = {
  study_health_check: { label: 'Study Health Check', render: () => <StudyHealthSetupForm /> },
  study_protocol_parser: { label: 'Study Protocol Parser', render: () => <StudyProtocolParserSetupForm /> },
  send_validator: { label: 'SEND Validator', render: () => <p className="mid-gray">Coming soon.</p> },
};

/** Generic agent setup page. Resolves the form component by agent slug from the URL. */
const AgentSetupPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const agentType = _notNil(slug) ? parseAgentUrlSlug(slug) : undefined;
  const config = _notNil(agentType) ? agentForms[agentType] : undefined;

  return (
    <div className="ph4 pb4 pt3" data-testid="agent-setup-page">
      <AgentBreadcrumb current={config?.label ?? 'Setup'} />
      {_notNil(config) ? config.render() : <p className="mid-gray">Agent not found.</p>}
    </div>
  );
};

export default AgentSetupPage;
